export default __webpack_public_path__ + "static/media/Prancheta 3.358b71d8.svg";